export default {
  name: "Editor",
  path: "/",
  meta: {
    title: "AI",
  },
};
